import { CustomButton, ResponsiveDialog } from "@hapinest/theme";
import { Box, Typography, useTheme } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useI18N } from "../../../common/common";
import { useBreakpoints } from "../../../hooks";
import CustomRichText from "../../widget/text/CustomRichText";

const BlockBuyingSharesDialog = ({ isOpen, onClose, content }) => {
    const { i18n } = useI18N();
    const theme = useTheme();
    const {isExtraSmallScreen} = useBreakpoints();

    const ctaButtonContent = useMemo(() => {
        const isInMarketplace = window.location.href.includes("/marketplace");
        return isInMarketplace ? content?.ctaButtonTargetPageMarketplace : content?.ctaButtonTargetPageDirectSales;
    }, [content?.ctaButtonTargetPageDirectSales, content?.ctaButtonTargetPageMarketplace]);

    return (
        <ResponsiveDialog
            open={isOpen}
            handleClose={onClose}
            hasCloseButton
            content={(
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    m={isExtraSmallScreen() ? 0 : theme.spacing(3, 5, 0, 5)}
                >
                    <Box
                        mb={3}
                    >
                        <LazyLoadImage
                            alt={content?.image?.title}
                            src={content?.image?.url}
                        />
                    </Box>
                    <Typography
                        variant="h1"
                        align="center"
                        gutterBottom
                    >
                        {content?.title}
                    </Typography>
                    {content?.description?.json && (
                        <CustomRichText
                            document={content?.description?.json}
                        />
                    )}
                </Box>
            )}
            actions={(
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gridGap={16}
                >
                    <CustomButton
                        variant="outlined"
                        color="black"
                        onClick={onClose}
                        size={"medium"}
                    >
                        {i18n("common.label.cancel")}
                    </CustomButton>
                    {ctaButtonContent && (
                        <CustomButton
                            variant={"contained"}
                            onClick={() => {
                                if (ctaButtonContent?.url) {
                                    window.open(ctaButtonContent.url, "_blank");
                                }
                            }}
                            size={"medium"}
                        >
                            {ctaButtonContent.label}
                        </CustomButton>
                    )}
                </Box>
            )}
        />
    );
};

BlockBuyingSharesDialog.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    content: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.shape({
            json: PropTypes.object,
        }),
        image: PropTypes.shape({
            url: PropTypes.string,
            title: PropTypes.string,
        }),
        ctaButtonTargetPageDirectSales: PropTypes.shape({
            label: PropTypes.string,
            url: PropTypes.string,
        }),
        ctaButtonTargetPageMarketplace: PropTypes.shape({
            label: PropTypes.string,
            url: PropTypes.string,
        }),
    }),
};

export default BlockBuyingSharesDialog;
